import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const ROLE_HOME = {
  super_admin: "/admin",
  admin: "/admin",
  finance_admin: "/admin",
  hr_admin: "/admin",
  support: "/admin",
  hr_consultant: "/consultant",
  employer_owner: "/employer",
  employer_admin: "/employer",
  hiring_manager: "/employer",
  interviewer: "/employer",
  candidate: "/candidate",
  employee: "/employee",
  franchise_owner: "/partner",
  franchise_recruiter: "/partner",
  institute_owner: "/institute",
  trainer: "/institute",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [extras, setExtras] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("js_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setExtras(data);
    } catch {
      localStorage.removeItem("js_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("js_token", data.token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("js_token", data.token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("js_token");
    setUser(null);
    setExtras({});
  };

  return (
    <AuthContext.Provider value={{ user, extras, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function homeFor(user) {
  if (!user) return "/login";
  return ROLE_HOME[user.role] || "/";
}
